import { Card, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@repo/ui";
import { useEffect, useMemo, useState } from "react";

const zodiacs = [
  { key: "aries", name: "เมษ" },
  { key: "taurus", name: "พฤษภ" },
  { key: "gemini", name: "เมถุน" },
  { key: "cancer", name: "กรกฎ" },
  { key: "leo", name: "สิงห์" },
  { key: "virgo", name: "กันย์" },
  { key: "libra", name: "ตุล" },
  { key: "scorpio", name: "พิจิก" },
  { key: "sagittarius", name: "ธนู" },
  { key: "capricorn", name: "มังกร" },
  { key: "aquarius", name: "กุมภ์" },
  { key: "pisces", name: "มีน" },
];

export function Daily() {
  const url = new URL(window.location.href);
  const initial = url.searchParams.get("sign") || "aries";
  const [sign, setSign] = useState(initial);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    params.set("sign", sign);
    history.replaceState(null, "", `?${params.toString()}`);
    document.title = `ดวงวันนี้ (${zodiacs.find((z) => z.key === sign)?.name}) — Lucky News`;
  }, [sign]);

  const horoscope = useMemo(() => generateHoroscope(sign), [sign]);

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <h1 className="font-display text-3xl">ดวงวันนี้</h1>
          <p className="text-foreground/70 text-sm mt-1">
            อัปเดต {new Date().toLocaleDateString("th-TH")}
          </p>
        </div>
        <Select value={sign} onValueChange={setSign}>
          <SelectTrigger className="w-[200px]">
            <SelectValue placeholder="เลือก ราศี" />
          </SelectTrigger>
          <SelectContent>
            {zodiacs.map((z) => (
              <SelectItem key={z.key} value={z.key}>
                {z.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <Card className="p-6 bg-card/60">
        <div className="grid md:grid-cols-3 gap-6">
          <div>
            <h3 className="font-display text-lg">ภาพรวม</h3>
            <p className="text-foreground/80 mt-2 whitespace-pre-line">{horoscope.overall}</p>
          </div>
          <div>
            <h3 className="font-display text-lg">การงาน & การเงิน</h3>
            <p className="text-foreground/80 mt-2 whitespace-pre-line">{horoscope.career}</p>
          </div>
          <div>
            <h3 className="font-display text-lg">ความรัก</h3>
            <p className="text-foreground/80 mt-2 whitespace-pre-line">{horoscope.love}</p>
          </div>
        </div>
      </Card>
    </div>
  );
}

function generateHoroscope(sign: string) {
  const daySeed = parseInt(new Date().toISOString().slice(0, 10).replace(/-/g, ""), 10);
  const code = sign.split("").reduce((acc, ch) => acc + ch.charCodeAt(0), 0) + daySeed;
  const pick = (arr: string[], offset: number) => arr[(code + offset) % arr.length];
  const tones = [
    "วันนี้พลังงานของคุณนิ่งและมั่นคง เหมาะสำหรับการวางแผนระยะยาว",
    "มีโอกาสใหม่ๆ เข้ามา อย่าลังเลที่จะคว้าไว้",
    "อย่าลืมพักผ่อนและให้เวลากับตัวเองมากขึ้น",
    "ความคิดสร้างสรรค์พุ่งสูง เหมาะกับงานที่ต้องใช้ไอเดีย",
  ];
  const money = [
    "การเงินเริ่มเห็นแนวโน้มที่ดีขึ้น จัดระเบียบรายรับรายจ่ายจะช่วยได้",
    "มีรายจ่ายเล็กๆ น้อยๆ เข้ามา แต่ยังควบคุมได้",
    "โอกาสด้านงานที่เกี่ยวข้องกับเทคโนโลยีหรือออนไลน์โดดเด่น",
    "เหมาะกับการเจรจาต่อรอง มีเกณฑ์ได้ดีลที่เป็นธรรม",
  ];
  const love = [
    "คนโสดมีเสน่ห์ แต่อย่าตัดสินใจเร็วเกินไป",
    "คนมีคู่ควรสื่อสารด้วยเหตุผล ความเข้าใจจะกลับมา",
    "ลองทำกิจกรรมใหม่ๆ ร่วมกัน จะช่วยกระชับความสัมพันธ์",
    "วันนี้เหมาะกับการเปิดใจและรับฟัง",
  ];
  return {
    overall: pick(tones, 1),
    career: pick(money, 2),
    love: pick(love, 3),
  };
}

export default Daily;
